import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Policies from 'modules/Policies/layout/Policies';

function PoliciesRoute() {
	return (
		<Routes>
			<Route path="*" element={<Policies />} />
		</Routes>
	);
}

export default PoliciesRoute;
